export default __webpack_public_path__ + "static/media/icon_info.3aff294a.svg";